import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "form__input pt-0" }
const _hoisted_3 = ["name"]
const _hoisted_4 = ["value", "selected"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["value", "placeholder"]
const _hoisted_7 = {
  class: "dropdown-list__options",
  role: "listbox"
}
const _hoisted_8 = ["onClick", "data-value"]
const _hoisted_9 = {
  key: 0,
  class: "buffer buffer--large"
}
const _hoisted_10 = {
  key: 1,
  class: "form__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.formClass)
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "form__label",
          for: _ctx.name
        }, _toDisplayString(_ctx.label), 9 /* TEXT, PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass({'dropdown-wrap': true, 'loading' : _ctx.loading, 'loading--dropdown' : _ctx.loading, 'dropdown-wrap--multiple': true, 'is-open': _ctx.dropdownOpen })
      }, [
        _createElementVNode("i", {
          class: "choices__chevron fi-angle-down",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
        }),
        _createElementVNode("div", {
          class: "choices__inner",
          tabindex: "0",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openDropdown && _ctx.openDropdown(...args))),
          onFocus: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openDropdown && _ctx.openDropdown(...args)))
        }, [
          _createElementVNode("select", {
            tabindex: "-1",
            ref: "input",
            name: _ctx.name,
            class: "dropdown__select--vue",
            style: {"height":"1px","opacity":"0","position":"absolute","width":"1px"},
            multiple: "multiple",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeInnerSelect && _ctx.changeInnerSelect(...args))),
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)), ["stop","prevent"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedOptions, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                value: item.value,
                selected: _ctx.innerSelect.includes(item.value)
              }, _toDisplayString(item.text), 9 /* TEXT, PROPS */, _hoisted_4))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innerSelect, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "choices__card",
                onClick: _withModifiers(($event: any) => (_ctx.removeSelectedItem(item)), ["stop"])
              }, _toDisplayString(_ctx.getOptionLabel(item)), 9 /* TEXT, PROPS */, _hoisted_5))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _createElementVNode("input", {
            type: "text",
            class: "choices__input",
            autocomplete: "off",
            "ref:filterboxmulti": "",
            tabindex: "-1",
            value: _ctx.filter,
            onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.preventEnter && _ctx.preventEnter(...args))),
            onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateFilter && _ctx.updateFilter(...args))),
            onChange: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.preventEnter && _ctx.preventEnter(...args)), ["stop"])),
            placeholder: _ctx.currentPlaceHolder
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6)
        ], 32 /* NEED_HYDRATION */),
        _createElementVNode("div", {
          class: _normalizeClass(["dropdown-list", { 'is-active': _ctx.dropdownOpen }]),
          "aria-expanded": "false"
        }, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleOptions, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["dropdown-list__option", {'is-highlighted': _ctx.innerSelect.includes(item.value)}]),
                role: "option",
                onClick: _withModifiers(($event: any) => (_ctx.selectItem(item)), ["stop"]),
                "data-value": item.value
              }, _toDisplayString(item.text), 11 /* TEXT, CLASS, PROPS */, _hoisted_8))
            }), 256 /* UNKEYED_FRAGMENT */))
          ])
        ], 2 /* CLASS */)
      ], 2 /* CLASS */),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.errorList.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorList, (error) => {
            return (_openBlock(), _createElementBlock("span", null, _toDisplayString(error), 1 /* TEXT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */)), [
    [_directive_click_outside, _ctx.closeDropdown]
  ])
}